export default __webpack_public_path__ + "static/media/bikeRental.f2edc7b5.jpg";